/* eslint-disable no-restricted-imports */

import { Button, EButtonType } from '@/components/Button';
import {
    selectVehicleAssetType,
    setIsVehicleRegistrationKnown,
} from '@/context/borrower';
import { EVehicleAssetType } from '@/context/borrower';
import {
    EDisplays,
    setDisplay,
    setVehicleManualEntry,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { useCopy } from '@/copy';
import { BuildYear } from '@/UserInput/BuildYear';
import { VehicleMake } from '@/UserInput/VehicleMake';
import { VehicleModel } from '@/UserInput/VehicleModel';
import { VehicleVariant } from '@/UserInput/VehicleVariant';
import { isCaravan } from '@/utils/glassGuideHelpers';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';

import { DisplayGlassOptions } from '../DisplayVehicleResults/DisplayGlassOptions/DisplayGlassOptions';

export const testId = 'VehicleDetailsRegoUnKnown';

export interface IVehicleDetailsRegoUnknownProps {
    showErrors: boolean;
}

export function VehicleDetailsRegoUnKnown({
    showErrors,
}: IVehicleDetailsRegoUnknownProps): JSX.Element {
    // ***** Redux State *****
    const baseId = 'screen-vehicleDetailsRegoUnknown';
    const dispatch = useAppDispatch();
    const { quietFallbackPrompt } = useCopy();
    const assetTitle = userFacingAssetTitle();
    const assetType = useAppSelector(selectVehicleAssetType);
    const disabledGlassesGuideVinLookup = useAppSelector(
        (state) => state.displayReducer.partner.disabledGlassesGuideVinLookup
    );
    const isTruckAsset = assetType === EVehicleAssetType.TRUCK_GT_4_5;

    function handleRegoClick(): void {
        dispatch(setIsVehicleRegistrationKnown(true));
    }

    function handleManualClick(): void {
        dispatch(setVehicleManualEntry(true));
        dispatch(setDisplay(EDisplays.MANUAL_VEHICLE));
    }

    return (
        <div data-testid={testId}>
            {!isTruckAsset && (
                <>
                    <BuildYear baseId={baseId} showErrors={showErrors} />
                    <VehicleMake baseId={baseId} showErrors={showErrors} />
                    <VehicleModel baseId={baseId} showErrors={showErrors} />
                    <VehicleVariant baseId={baseId} showErrors={showErrors} />
                    <DisplayGlassOptions />
                </>
            )}
            {isTruckAsset && (
                <p
                    className={`${
                        quietFallbackPrompt ? 'text-sm' : 'text-lg'
                    } px-4 text-center pb-4`}
                >
                    Please enter your truck details manually.
                </p>
            )}
            {!isTruckAsset && (
                <p
                    className={`${
                        quietFallbackPrompt ? 'text-sm' : 'text-lg'
                    } px-4 text-center pb-4`}
                >
                    {`Can't find the ${assetTitle.toLowerCase()}?`}
                </p>
            )}
            <div className='flex space-x-4 pb-4'>
                {!isCaravan(assetType) &&
                    !disabledGlassesGuideVinLookup &&
                    !isTruckAsset && (
                        <Button
                            type={EButtonType.SECONDARY_OUTLINE}
                            onClick={handleRegoClick}
                        >
                            Search by Rego
                        </Button>
                    )}
                <Button
                    type={EButtonType.SECONDARY_OUTLINE}
                    onClick={handleManualClick}
                >
                    Enter Manually
                </Button>
            </div>
        </div>
    );
}
